export default function Logo({ size = 96 }: { size?: number }) {
  const src = "/agbaza-logo.png";
  return (
    <div className="flex flex-col items-center gap-2 select-none">
      <div style={{ width: size, height: size }} className="flex items-center justify-center">
        <img
          src={src}
          alt="agbaza"
          width={size}
          height={size}
          onError={(e) => {
            const el = e.currentTarget as HTMLImageElement;
            el.style.display = "none";
          }}
        />
        <div className="hidden" aria-hidden />
      </div>
      <div className="text-4xl font-semibold" style={{ color: "#00553E" }}>
        agbaza
      </div>
    </div>
  );
}

